import { createRouteRef } from '@backstage/frontend-plugin-api';

export const organizationRouteRef = createRouteRef();
export const catalogGuideRouteRef = createRouteRef();
